import Vue from 'vue'
import Router from '@/router'
import axios from 'axios'
import Utils from '@/utils'
import Cart from '@/cart'
import Crypto from 'crypto'

// URL and endpoint constants
const LOGIN_URL = 'cart/api/login/request'

import { fb, db, fn, auth, sentry } from '@/globals'

export default {

  // User object will let us check authentication status
  context: {
    identified: false,
    authenticated: false,
    name: 'Guest',
    uid: null,
    email: '',
    isNew: false
  },

  setSocket(socket) {
    console.log('setting socket', socket)
    this.context.socket = socket
  },
  
  setSentry() {
    if (process.env.VUE_APP_ENVIRONMENT != 'local_dev') {
      console.log('UserService: Setting up Sentry user info', this.context)
      let user = this.context
      sentry.configureScope(scope => {
        scope.setUser({
          id: user.uid,
          email: user.email
        })
      })
    }
  },

  checkLogin() {
    auth.onAuthStateChanged((user) => {
      if (user) {
        // User is signed in.
        console.log('Logged in', user)
        this.context.authenticated = true
        this.context.name = user.displayName
        this.context.uid = user.uid
        this.context.email = user.email
        Cart.data.customerId = user.uid
        this.setSentry()
        window.localStorage.removeItem('phase')
      } else {
        // No user is signed in.
        console.log('Not logged in')
        Utils.removeCookie('nur')
        this.context.authenticated = false
      }
    })
  },

  // request login code to be sent via email
  async login(loginData) {
    console.log('User.js: login()')
    let request = {
      action: 'requestCode',
      loginData: loginData
    }
    
    try {
      let cartLoginFn = fn.httpsCallable('calls-commerce-cart-login')
      let response = await cartLoginFn(request)
      console.log('login() response:', response)
      window.localStorage.setItem('phase', 'awaiting-verification')
      return 'awaiting-verification'
    } catch (e) {
      if (err.code == 'user-not-found') {
        return 'user-not-found'
      } else {
        console.error('cartLoginFn failed:', e)
        return 'error'
      }
    }
  },

  // login with generated code that came via email
  async loginWithCode(email, pwd) {
    try {
      let user = await auth.signInWithEmailAndPassword(email, pwd)
      console.log('User should be logged in', user)

      // TODO: invalidate code
    } catch (err) {
      console.error('Error while loging in', err)
      return 'init'
    }
  },

  async registerUser(email) {
    if (auth.currentUser == null) {
      console.log('Registering new user', email)
      // Is thre already a user with this email?

      // The user is really not logged in yet
      Utils.setCookie('nur', true) // New User Registerd
      let pwd = Crypto.randomBytes(20).toString('hex')
      return auth.createUserWithEmailAndPassword(email, pwd)
      .then(async (userRecord) => {
        console.log('User registered', userRecord)
        // Store the user basic document
        await this.addUserData({
          uid: userRecord.user.uid
        })
        return true
      })
      .catch((error) => {
        // Handle Errors here.
        console.error('Error while registering new customer', error)
        return false
      })
    } else {
      console.log('User not registered, already logged in')
      return true
    }
  },

  async addUserData(args) {
    console.log('Adding user details', args)
    // TODO change this
    let userRef = db.collection(`shops/${Cart.shopId}/customers`).doc(args.uid)
    return userRef.set({
      name: '',
      address: {}
    })
  },

  updateEmail(email) {
    if (auth.currentUser !== null) {

    }
  },

  checkEmail(email) {
    console.log('Checking email')
    // This actually finds out the user really exists in the DB and is allowed to sign in
    return auth.fetchSignInMethodsForEmail(email)
    .then(methods => {
      // The presence of method means the user exists
      if (methods.length > 0) {
        console.log('Available methods', methods, methods.includes('password'))
        return methods.includes('password')
      } else {
        console.log('No methods available for email', email)
        return false
      }
    })
    .catch(err => {
      console.error(err)
      return false
    })
  },

  logout() {
    console.log('Signing out')
    this.context.authenticated = false
    auth.signOut()
  },
  //
  // checkAuth() {
  //   var jwt = Utils.getCookie('id_token')
  //   if (jwt) {
  //     this.context.authenticated = true
  //   }else {
  //     this.context.authenticated = false
  //   }
  //   console.log('Checking authorization', this.context.authenticated)
  // },


}
